import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { updateVisit } from '../../services/visitService'; // Import the updateVisit service

const EditVisitModal = ({ open, onClose, visit, onVisitEdited }) => {
    const [formData, setFormData] = useState({
        diagnose: '',
        anamnesa: '',
        echo_report: '',
        treatment: '',
    });

    useEffect(() => {
        if (visit) {
            setFormData({
                diagnose: visit.diagnose || '',
                anamnesa: visit.anamnesa || '',
                echo_report: visit.echo_report || '',
                treatment: visit.treatment || '',
            });
        }
    }, [visit]);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async () => {
        if (!visit || !visit.id) {
            console.error('Missing visit id, cannot update');
            return;
        }
        const payload = {
            id: visit.id, // ensure id explicitly present
            diagnose: formData.diagnose,
            anamnesa: formData.anamnesa,
            echo_report: formData.echo_report,
            treatment: formData.treatment
        };
        console.log('Submitting visit update payload:', payload);
        try {
            const response = await updateVisit(payload);
            if (response.success && response.data?.status === 'success') {
                const updated = response.data.visit 
                    ? { ...visit, ...response.data.visit } 
                    : { ...visit, ...payload };
                console.log('Updated visit data:', updated);
                onVisitEdited(updated);
                onClose();
            } else {
                console.error('Error updating visit:', response.data?.message || response.message);
            }
        } catch (error) {
            console.error('Error updating visit:', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Edit Visit</DialogTitle>
            <DialogContent>
                <TextField
                    name="diagnose"
                    label="Diagnose"
                    value={formData.diagnose}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                    fullWidth
                    margin="normal"
                    sx={{ '& textarea': { resize: 'vertical' } }} // Enable vertical resizing
                />
                <TextField
                    name="anamnesa"
                    label="Anamnesis"
                    value={formData.anamnesa}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                    fullWidth
                    margin="normal"
                    sx={{ '& textarea': { resize: 'vertical' } }}
                />
                <TextField
                    name="echo_report"
                    label="ECHO Report"
                    value={formData.echo_report}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                    fullWidth
                    margin="normal"
                    sx={{ '& textarea': { resize: 'vertical' } }}
                />
                <TextField
                    name="treatment"
                    label="Treatment"
                    value={formData.treatment}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                    fullWidth
                    margin="normal"
                    sx={{ '& textarea': { resize: 'vertical' } }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">Save Changes</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditVisitModal;
